import { ArrowRight, Heart } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#F4F1EB]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 pt-12 pb-24 lg:pt-20 lg:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Text */}
          <div className="lg:col-span-7 animate-fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FAF8F5] border border-[#E2DCD0] mb-8">
              <Heart size={14} className="text-[#692128]" strokeWidth={2.2} />
              <span className="text-xs tracking-[0.22em] uppercase text-[#5C5856] font-semibold">
                A Faith-Grounded Nonprofit
              </span>
            </div>

            <h1 className="font-serif text-[#2C2A29] text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Strengthening families.
              <br />
              <span className="italic text-[#692128]">Honoring legacy.</span>
              <br />
              Building grace.
            </h1>

            <p className="mt-8 max-w-xl text-lg text-[#5C5856] leading-relaxed">
              Guardian Grace Family &amp; Community Foundation walks alongside families,
              caregivers, veterans, and those impacted by chronic illness — offering
              compassion, advocacy, and steady, hands-on support.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#donate"
                data-testid="hero-donate-btn"
                className="group inline-flex items-center gap-2 bg-[#692128] text-[#F4F1EB] hover:bg-[#8B2635] rounded-full px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300"
              >
                Donate to Our Mission
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="#programs"
                data-testid="hero-programs-link"
                className="inline-flex items-center gap-2 border border-[#692128]/30 text-[#692128] hover:bg-[#692128] hover:text-[#F4F1EB] rounded-full px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300"
              >
                Explore Our Programs
              </a>
            </div>

            <div className="mt-12 flex items-center gap-6">
              <div className="flex -space-x-2">
                <span className="w-9 h-9 rounded-full bg-[#692128] ring-2 ring-[#F4F1EB]" />
                <span className="w-9 h-9 rounded-full bg-[#C89F5D] ring-2 ring-[#F4F1EB]" />
                <span className="w-9 h-9 rounded-full bg-[#2A4747] ring-2 ring-[#F4F1EB]" />
              </div>
              <p className="text-sm text-[#5C5856] max-w-xs leading-snug">
                Serving <span className="text-[#2C2A29] font-medium">families, caregivers &amp; veterans</span> — based in Georgia, reaching communities wherever the need calls.
              </p>
            </div>
          </div>

          {/* Image collage */}
          <div className="lg:col-span-5 relative animate-fade-up" style={{ animationDelay: "150ms" }}>
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://plus.unsplash.com/premium_photo-1661677204235-23fd47fcb4be?fm=jpg&q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.1.0"
                alt="A Black family enjoying time together outdoors"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C2A29]/30 via-transparent to-transparent" />
            </div>

            <div className="hidden md:block absolute -bottom-8 -left-8 w-44 bg-[#FAF8F5] border border-[#E2DCD0] rounded-2xl p-5 shadow-lg">
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#8B2635] font-bold mb-2">
                Est. in Love &amp; Service
              </div>
              <div className="font-serif text-2xl text-[#2C2A29] leading-tight">
                A legacy of <span className="italic">grace</span>.
              </div>
            </div>

            <div className="hidden md:flex absolute -top-6 -right-4 items-center gap-2 bg-[#692128] text-[#F4F1EB] rounded-full px-4 py-2 shadow-lg">
              <span className="w-2 h-2 rounded-full bg-[#C89F5D]" />
              <span className="text-xs tracking-[0.22em] uppercase font-semibold">Serving Nationwide</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
